// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "../feature/dataSlice";

export const store = configureStore({
  reducer: {
    data: dataReducer,
  },
  // O thunk é adicionado automaticamente, então não precisa adicionar manualmente
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
